import { getMessage, getPatientChat } from '@/api/clinic'
import moment from "moment";
var chat = {
  currentChatId: null,  // 进入聊天室就把chatid赋值给他
  defaultTime: '2025-09-01 12:00:00',
  inFlight: new Set(), // 防重入：正在拉取的 chatid 集合

  // 回调函数
  updateChatList : null,  // 更新列表
  updateChatMsg: null,  // 更新消息
  updateTotalUnread: null, // 更新总未读消息数量
  

  // 当监听到我被拉入或踢出群聊时的操作
  getChatList() {
    const params = {
      uid: JSON.parse(localStorage.getItem('appuser')).id,
    }
    // 获取我的所有会话列表
    getPatientChat(params).then(res => {
      let chatList = res?.data?.data || []

      // 更新本地会话列表信息
      chatList.forEach(item => {
        const local = this.getLocalData(item.chat.chatid)
        item.unread = local.unread  // 未读消息数量
        item.lastTime = local.lastTime  // 最后聊天时间
        this.getChatMsg(item.chat.chatid) // 这一步是为了如果socket不在线，重新进入可以获取不在线期间的未读消息数
      })
      
      chatList =  chatList.sort((a, b) => new Date(b.lastTime) - new Date(a.lastTime))
      localStorage.setItem('chatList', JSON.stringify(chatList))

      // 更新列表
      if (this.updateChatList) {
         this.updateChatList()
      }
    })
  },

  // 获取新消息
  getChatMsg(chatid) {
    // 防止并发重复拉取导致的重复追加
    if (this.inFlight.has(chatid)) return
    this.inFlight.add(chatid)

    const local = this.getLocalData(chatid)

    const params = {
      chatid,
      end: local.lastTime,
    }

    getMessage(params).then(res => {
      const msgs = res?.data?.data || []
      if (msgs.length) {
        this.saveMsgToLocal(chatid, msgs)

        // 通知页面刷新
        if (this.updateChatMsg) this.updateChatMsg(chatid, msgs)
        if (this.updateChatList) this.updateChatList()
      }
    }).finally(() => {
      this.inFlight.delete(chatid)
    })
  },

  // 从本地拿消息数据
  getLocalData(chatid) {
    const cache = localStorage.getItem(chatid)
    return cache
      ? JSON.parse(cache)
      : { msgs: [], lastTime: this.defaultTime, unread: 0 }
  },

  // 将聊天消息存入本地
  saveMsgToLocal(chatid, msgs) {
    // 更新消息
    const cache = this.getLocalData(chatid)

    // 基于关键信息的去重（createtime+senderid+type+文本/图片）
    const existKeys = new Set(
      cache.msgs.map(m => `${m.createtime}|${m.senderid}|${m.type}|${m.text || m.img || ''}`)
    )
    const newMsgs = msgs.filter(
      m => !existKeys.has(`${m.createtime}|${m.senderid}|${m.type}|${m.text || m.img || ''}`)
    )
    if (newMsgs.length === 0) return

    // 追加消息
    cache.msgs.push(...newMsgs)
    // 更新最后一条时间
    cache.lastTime = newMsgs[newMsgs.length - 1].createtime
    // 未读数增加,判断是否在当前会话
    if (chatid === this.currentChatId) {
      cache.unread = 0  // 如果正在该房间，未读数为0
    } else {
      cache.unread += newMsgs.length
    }
    // 存回 localStorage
    localStorage.setItem(chatid, JSON.stringify(cache))

    // 更新会话列表，如果这边不更新会话列表，接收到消息无法更新本地的列表的最后时间和未读消息数量
    let chatList = JSON.parse(localStorage.getItem('chatList')) || []
    const index = chatList.findIndex(item => item.chat.chatid === chatid )
    if (index > -1) {
      // 更新已有的
      chatList[index].unread = cache.unread
      chatList[index].lastTime = cache.lastTime
    } else {
      // 如果列表里没有，就新增
      chatList.push({
        chatid,
        lastTime: cache.lastTime,
        unread: cache.unread,
      })
    }
    chatList =  chatList.sort((a, b) => new Date(b.lastTime) - new Date(a.lastTime))
    localStorage.setItem('chatList', JSON.stringify(chatList))

    // 触发页面回调
    // if (this.updateChatMsg) this.updateChatMsg(chatid, msgs)
    // if (this.updateChatList) this.updateChatList()
  },

  // 清空未读消息数量
  clearUnread(chatid) {
    const cache = this.getLocalData(chatid)
    cache.unread = 0
    localStorage.setItem(chatid, JSON.stringify(cache))
    // if (this.updateChatList) this.updateChatList()
  },

  // 计算未读消息数量总和
  getTotalUnread() {
    const chatList = JSON.parse(localStorage.getItem('chatList')) || []
    let totalUnread = 0
    chatList.forEach(item => {
      totalUnread += item.unread || 0
    })
    return totalUnread
  }
}

export default chat
